import React from "react";
import ErrorImage from "../../images/gfx/error-504.svg";
import PageContainer from "../../layout/page-container/PageContainer";
import { Link } from "react-router-dom";
import { Block, BlockContent, Button } from "../../components/Component";
import { deleteCookie } from "../../utils/Utils";

const Error504Modern = () => {
  const handleSignout = () => {
    deleteCookie("access_token");
    localStorage.clear();
  };

  return (
    <PageContainer>
      <Block className="nk-block-middle wide-md mx-auto">
        <BlockContent className="nk-error-ld text-center">
          <img className="nk-error-gfx" src={ErrorImage} alt="error" />
          <div className="wide-xs mx-auto">
            <h3 className="nk-error-title">Oops! Something went wrong.</h3>
            <p className="nk-error-text">
              We apologize for the inconvenience. It looks like something went wrong on our end. Please try again later or contact support if the problem persists.
            </p>
            <Link to={`${process.env.PUBLIC_URL}/`}>
              <Button color="primary" size="lg" className="m-2">
                Back To Home
              </Button>
            </Link>
            <Link to={`${process.env.PUBLIC_URL}/`} onClick={handleSignout}>
              <Button color="danger" size="lg" className="m-2">
                Sign Out
              </Button>
            </Link>
          </div>
        </BlockContent>
      </Block>
    </PageContainer>
  );
};
export default Error504Modern;
